// Get the .site-header element
const siteHeader = document.querySelector('.site-header');

// Define the CSS variable name
const cssVariableName = '--header-height';

// Create a ResizeObserver
const headerResizeObserver = new ResizeObserver(entries => {
	for (const entry of entries) {
		// Update the CSS variable value with the new height
		document.documentElement.style.setProperty(cssVariableName, `${entry.contentRect.height}px`);
	}
});

// Observe the .site-header element
headerResizeObserver.observe(siteHeader);


// Get the .announcementBar element
const announcementBar = document.querySelector('.announcementBar');

if (announcementBar)
{

	// Define the CSS variable name
	const cssAnnouncementVariableName = '--announcementbar-height';

	// Create a ResizeObserver
	const announcementBarResizeObserver = new ResizeObserver(entries => {
		for (const entry of entries) {
			// Update the CSS variable value with the new height
			document.documentElement.style.setProperty(cssAnnouncementVariableName, `${entry.contentRect.height}px`);
		}
	});

	// Observe the .site-header element
	announcementBarResizeObserver.observe(announcementBar);
}


